import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const OpportunityHub = () => {
  const navigate = useNavigate()
  const [publications, setPublications] = useState()
  // const [research_type, setResearchType] = useState("all")
  const [publication_type, setPublicationType] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  // console.log("The publication are:",publications)
  useEffect(() => {
    const fetchAllPublications = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/researcher/create-opportunity/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'x-api-key': process.env.REACT_APP_X_API_KEY,
          },
        })
        // console.log("The response is:",res.data)
        setPublications(res.data)
      } catch (error) {
        console.log("The error while getting publications",error)
        toast.error(error.code)
      }
    }
    fetchAllPublications()
  }, [])

  const handleViewDetails = (projectId) => {
    navigate(`/marketplace/independent_researcher/dashboard/opportunity_hub/${projectId}`)
  };

  return (
   <div className="p-0 md:p-6 w-full mx-auto">
      {/* Header */}
      <div className="flex justify-between flex-col md:flex-row mb-8">
        <div className="flex  items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h1 className="text-lg md:text-2xl font-semibold text-gray-900">Researcher Opportunities</h1>
            <p className="text-gray-500 mt-0.5">Manage and track all your  opportunities in one place</p>
          </div>
        </div>
        {/* Add Publication Buttons */}
        <div className="flex justify-center md:justify-end flex-wrap gap-3 mt-6">
          <button onClick={() => navigate("/marketplace/independent_researcher/dashboard/opportunity_hub/create")} className="px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Create Opportunity
          </button>
          
         
        </div>
      </div>
      <div className="mb-6 mt-12 w-full flex flex-col md:flex-row items-center gap-3 w-full mx-auto">
        {/* Search Input */}
        <div className="w-full relative flex-1">
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search...Theoretical Idea,Lab Experiment,Prototype,Industrial Application"
            className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
        </div>
        <select
          className="w-full md:w-auto px-12 py-3 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 12px center'
          }}
          value={publication_type}
          onChange={(e) => setPublicationType(e.target.value)}
        >
          <option value="">All</option>
          <option value="pdf">Pdf</option>
          <option value="doc">Docs</option>
          <option value="code">Code</option>
          <option value="image">Images</option>
          <option value="audio">Audios</option>
          <option value="video">Videos</option>
        </select>
      </div>
      {/* Projects Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {!publications ? (
          // Loader
          <div className="w-full flex justify-center items-center h-32">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
          </div>
        ) : publications?.length === 0 ? (
          // No publications
          <div className="text-center text-gray-500 py-10">
            No publications found.
          </div>
        ) : (
          publications && publications?.filter((publication) => publication_type.trim() ? publication.publication_type === publication_type.trim() : true)?.filter((publication) => searchTerm.trim() ? publication.name.toLowerCase().includes(searchTerm.trim().toLowerCase()) : true)?.map((publication) => (
            <div
              key={publication.id}
              className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-200 flex flex-col"
            >
      <div className="p-3 border border-gray-200  cursor-pointer transition-all duration-200 hover:shadow-md">

  <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {publication?.domain}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {publication?.collaboration}
    </span>
    
    {/* <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {publication?.topic_of_interest}
    </span> */}
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {publication?.maturity}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {publication?.visibility}
    </span>
  </div>
</div>
              {/* Media Preview */}
              {publication.publication_type === "image" && (
                <img
                  src={publication.file}
                  alt={publication.name}
                  className="w-full h-48 object-cover"
                />
              )}
              {publication.publication_type === "pdf" && (
                <iframe
                  src={`${publication.file}#toolbar=0`}
                  title={publication.name}
                  className="w-full h-48"
                />
              )}
              {(publication.publication_type === "doc" || publication.type === "docx") && (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    publication.file
                  )}&embedded=true`}
                  title={publication.name}
                  className="w-full h-48"
                />
              )}
              {publication.publication_type === "video" && (
                <video
                  src={publication.file}
                  controls
                  className="w-full h-48 object-cover"
                />
              )}
              {publication.publication_type === "audio" && (
                <div className="w-full h-48 flex items-center justify-center bg-gray-100">
                  <audio src={publication.file} controls className="w-full px-4" />
                </div>
              )}
              {/* Content */}
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <h2 className="text-lg font-semibold text-gray-900">
                    {publication.name}
                  </h2>
                </div>
                <p className="text-sm text-gray-600 mt-2 flex-grow">
                  {publication.summary}
                </p>
                {/* Button */}
                <button
                  onClick={() => handleViewDetails(publication.id)}
                  className="mt-6 w-full py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  View Details
                </button>
              </div>
            </div>
          )))
        }
      </div>
    </div>
  );
};

export default OpportunityHub;
